var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "skin-tools", class: { "is-open": _vm.isOpen } },
    [
      _c(
        "a",
        {
          staticClass: "skin-tools-action",
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-cog" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "skin-tools-content" }, [
        _c("h5", { staticClass: "mt-2" }, [_vm._v("Select Skin")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "skins" },
          _vm._l(_vm.skins, function (skin) {
            return _c("div", { key: skin.slug, staticClass: "skin-item" }, [
              _c(
                "a",
                {
                  staticClass: "skin-radio",
                  class: { active: skin.slug === _vm.selectedSkin },
                  attrs: { title: skin.title, href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectSkin(skin)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: skin.img },
                  }),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }